import { render, staticRenderFns } from "./LogoDesign.vue?vue&type=template&id=789afbaa&scoped=true"
import script from "./LogoDesign.vue?vue&type=script&lang=js"
export * from "./LogoDesign.vue?vue&type=script&lang=js"
import style0 from "./LogoDesign.vue?vue&type=style&index=0&id=789afbaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789afbaa",
  null
  
)

export default component.exports